var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.content,"placement":"top"}},[_c('i',{staticClass:"icon el-icon-warning-outline"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }